import React, { Component } from 'react';

import { element, string } from 'prop-types';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { ContainerProvider } from '@philips-emr/tws-core/lib/component';
import { arrayOf, oneOfType } from '@philips-emr/tws-core/lib/component/prop-types';
import { getSlot, propagateProps } from '@philips-emr/tws-utils';

import './filtered-list.scss';

const filterAcceptedTypes = [
  ComponentType.BEHAVIOR,
  ComponentType.FORM,
];

const listAcceptedTypes = [
  ComponentType.BEHAVIOR,
  ComponentType.LIST,
];

@AwesomeComponent({ type: ComponentType.AGGREGATOR })
class FilteredList extends Component {

  static propTypes = {
    uuid: string,
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
  };

  state = {};

  onSubmit = ({ record }) => {
    this.setState({
      parameters: record,
      reset: true,
    }, () => this.setState({ reset: false }));
  };

  renderFilter() {
    const filterAreaChild = getSlot(this.props.children, 'filter');

    return propagateProps(filterAreaChild, {
      onSubmit: this.onSubmit,
      onCancel: this.onSubmit,
    });
  }

  renderList() {
    const listAreaChild = getSlot(this.props.children, 'list');

    return propagateProps(listAreaChild, {
      parameters: this.state.parameters,
      reset: this.state.reset,
    });
  }

  render() {
    const { uuid } = this.props;
    const Container  = ContainerProvider.provide(this);

    return (
      <div className="c-filtered-list" >
        <Container acceptedTypes={filterAcceptedTypes} className="c-filtered-list__filter" uuid={uuid} slot="filter" >
          {this.renderFilter()}
        </Container>

        <Container acceptedTypes={listAcceptedTypes} className="c-filtered-list__list" uuid={uuid} slot="list" >
          {this.renderList()}
        </Container>
      </div>
    );
  }

}

export default FilteredList;
